import React, { Component } from 'react'
import ConnectLink from '../components/ConnectLink'
import { DRUPAL_PLUGIN_URL } from 'constants/ResourcesConstants'
import { popUp } from '../helpers'

class DrupalInstaller extends Component {
  handleConnect = () => {
    popUp({ path: DRUPAL_PLUGIN_URL })
  }

  render() {
    return (
      <div>
        <p>The Drift Drupal Extension is provided via our community. Click below to download the plugin and upload it to your Drupal site 
          via the extend section of your Drupal admin panel.</p>

        <p>After installing the plugin, you should see it as an installed module named <b>Drift - Communication Tool</b>, and be able to configure it
          in the admin panel under <i>/admin/config/services/drift</i>.</p>
        <ConnectLink
          label="Download Drupal Module"
          handleConnect={this.handleConnect}
          connectorType="button"
          buttonType="tertiary"
        />
      </div>
    )
  }
}

export default DrupalInstaller



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/DrupalInstaller.js